
export function initGradientVideoLoader() {
  const videos = document.querySelectorAll("video.video-gradient-overlay");
  const observerOptions = {
    rootMargin: "0px 0px 200px 0px",
    threshold: 0.1,
  };

  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const videoEl = entry.target;
        if (!videoEl.src && videoEl.dataset.src) {
          videoEl.src = videoEl.dataset.src;
          videoEl.load();
        }
        observer.unobserve(videoEl);
      }
    });
  }, observerOptions);

  videos.forEach(videoEl => {
    videoEl.removeAttribute("src");
    videoObserver.observe(videoEl);
  });
}
 